import axios from "axios";
import { baseUrl } from "../config/url";

export interface IExchangeInfoRes {
  currency_from: string;
  currency_to: string;
  amount_from: number;
  amount_to: number;
  address_from: string;
  address_to: string;
  status: string;
  extera_from: string;
  extera_to: string;
  hash_from: string;
  hash_to: string;
}

export const exchangeInfoService = (exchangeID: string | undefined) =>
  axios.get(`${baseUrl}getExchangeInfo?exchangeID=${exchangeID}`, { withCredentials: true });
